import React, { useEffect, useState } from "react";
import { useParams } from "react-router";

import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import Sidebar from "components/Sidebar";
import { Player } from "video-react";
import { constants } from "../../constants";
export default function NewsItem(newsId) {
  const [isloaded, setIsLoaded] = useState(false);
  const [news, setNews] = useState(null);
  let navigate = useNavigate();

  const params = useParams();
  console.log("News ID: ", params.newsId);
  useEffect(() => {
    if (!isloaded) {
      axios
        .get(constants.SERVICE_URL + "/api/articles/" + params.newsId)
        .then((res) => {
          console.log("response: ", res);
          setIsLoaded(true);
          setNews(res.data);
        })
        .catch((err) => alert("Fail to get data from api"));
    }
  }, []);

  const publishNews = (e) => {
    const formData = new FormData();
    formData.append("id", params.newsId);
    formData.append("is_publish", !news.is_publish);
    console.log("form Data: ", formData);

    axios
      .put(constants.SERVICE_URL + "/api/articles/" + params.newsId, formData)
      .then((res) => {
        // navigate("/news");
        // navigate("/news/item/" + res.data.id);
        window.location.reload();
      })
      .catch((err) => alert("File Upload Error"));

    e.preventDefault();
  };

  const pushNotification = (e) => {
    const formData = new FormData();
    // formData.append("id", params.newsId);
    // formData.append("is_publish", !news.is_publish);
    // console.log("form Data: ", formData);

    axios
      .post(
        constants.SERVICE_URL + "/api/send-notification/" + params.newsId,
        formData
      )
      .then((res) => {
        // navigate("/news");
        // navigate("/news/item/" + res.data.id);
        // window.location.reload();
        alert("A new notification has been pushed.");
      })
      .catch((err) => alert("Push notification failed : " + err));

    e.preventDefault();
  };
  // const gotoEdit = () => {
  //   let path = `newPath`;
  //   navigate(path);
  // };
  // const addNews = () => {
  //   let path = `/news/add`;
  //   navigate(path);
  // };
  return (
    <>
      <Sidebar />
      <div className="relative md:ml-64 bg-blueGray-100">
        <div className="px-4 md:px-10 mx-auto w-full -m-24 md:pt-32 pb-32 pt-12">
          <div className="flex flex-wrap mt-4">
            <div className="w-full xl:w-8/12 mb-12 xl:mb-0 px-4">
              <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
                <div className="rounded-t mb-0 px-4 py-3 border-0">
                  <div className="flex flex-wrap items-center">
                    <div className="relative w-full px-4 max-w-full flex-grow flex-1">
                      <h3 className="font-semibold text-base text-blueGray-700">
                        New Details
                      </h3>
                    </div>
                    <div className="relative w-full px-4 max-w-full flex-grow flex-1 text-right">
                      <button
                        className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold text-xs font-bold uppercase py-2 px-3 rounded inline-flex items-center ml-2"
                        onClick={pushNotification}
                      >
                        <span>Send Notification</span>
                      </button>

                      <button
                        className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold text-xs font-bold uppercase py-2 px-3 rounded inline-flex items-center ml-2"
                        onClick={publishNews}
                      >
                        <span>
                          {news?.is_publish ? "UnPublish" : "Publish"}
                        </span>
                      </button>

                      <Link to={"/news/edit/" + params.newsId}>
                        <button
                          className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold text-xs font-bold uppercase py-2 px-3 rounded inline-flex items-center ml-2"
                          // onClick={gotoEdit(item.id)}
                        >
                          <span>Edit</span>
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="block w-full overflow-x-auto p-4">
                  <table className="items-center w-full bg-transparent border-collapse">
                    <tbody>
                      <tr>
                        <th className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left">
                          Headline
                        </th>
                        <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                          {news?.headline}
                        </td>
                      </tr>
                      <tr>
                        <th className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left">
                          Title
                        </th>
                        <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                          {news?.title}
                        </td>
                      </tr>
                      <tr>
                        <th className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left">
                          Body
                        </th>
                        <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                          {news?.body}
                        </td>
                      </tr>
                      <tr>
                        <th className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left">
                          Source Url
                        </th>
                        <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                          <a
                            href={news?.source_url}
                            target="_blank"
                            rel="noopener"
                          >
                            {news?.source_url}
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <th className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left">
                          Status
                        </th>
                        <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                          {news?.is_publish ? "Published" : "UnPublished"}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            {(news?.image_path || news?.video_path) && (
              <div className="w-full xl:w-4/12 px-4">
                <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
                  <div className="rounded-t mb-0 px-4 py-3 border-0">
                    <div className="flex flex-wrap items-center">
                      <div className="relative w-full px-4 max-w-full flex-grow flex-1">
                        <h3 className="font-semibold text-base text-blueGray-700">
                          Preview upload file
                        </h3>
                      </div>
                      <div className="relative w-full px-4 max-w-full flex-grow flex-1 text-right"></div>
                    </div>
                  </div>
                  <div className="block w-full overflow-x-auto">
                    <div className="items-center w-full bg-transparent border-collapse">
                      {news?.image_path && (
                        <img
                          src={
                            constants.SERVICE_URL +
                            "/uploads/" +
                            news?.image_path
                          }
                        />
                      )}

                      <br />
                      {news?.video_path && (
                        <Player
                          playsInline
                          src={
                            constants.SERVICE_URL +
                            "/uploads/" +
                            news?.video_path
                          }
                          fluid={false}
                          width={480}
                          height={272}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <footer className="block py-4">
            <div className="container mx-auto px-4">
              <hr className="mb-4 border-b-1 border-blueGray-200" />
              <div className="flex flex-wrap items-center md:justify-between justify-center">
                <div className="w-full md:w-4/12 px-4">
                  <div className="text-sm text-blueGray-500 font-semibold py-1">
                    Copyright © {new Date().getFullYear()}{" "}
                    <a
                      href="https://www.creative-tim.com"
                      className="text-blueGray-500 hover:text-blueGray-700 text-sm font-semibold py-1"
                    >
                      Mediaset.no
                    </a>
                  </div>
                </div>
                <div className="w-full md:w-8/12 px-4">
                  <ul className="flex flex-wrap list-none md:justify-end  justify-center">
                    <li>
                      <a
                        href="https://www.creative-tim.com"
                        className="text-blueGray-600 hover:text-blueGray-800 text-sm font-semibold block py-1 px-3"
                      >
                        Mediaset.no
                      </a>
                    </li>
                    {/* <li>
                    <a
                      href="https://www.creative-tim.com/presentation"
                      className="text-blueGray-600 hover:text-blueGray-800 text-sm font-semibold block py-1 px-3"
                    >
                      About Us
                    </a>
                  </li>
                  <li>
                    <a
                      href="http://blog.creative-tim.com"
                      className="text-blueGray-600 hover:text-blueGray-800 text-sm font-semibold block py-1 px-3"
                    >
                      Blog
                    </a>
                  </li> */}
                    {/* <li>
                    <a
                      href="https://github.com/creativetimofficial/tailwind-starter-kit/blob/main/LICENSE.md"
                      className="text-blueGray-600 hover:text-blueGray-800 text-sm font-semibold block py-1 px-3"
                    >
                      MIT License
                    </a>
                  </li> */}
                  </ul>
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </>
  );
}
